/*
 * @作者: Nan(yuannan@hztianque.com)
 * @描述: 台账搜索组件
 * @创建日期: 2020-05-06 14:44:31
 */
<template>
  <Row
    class="s-search"
    :gutter="40">
    <Col
      span="6"
      v-for="(item, index) in data"
      :key="index">
      <label v-if="item.label">{{item.label}}:</label>
      <search-item
        :ref="'ref' + index"
        :data="item"
        :condition="condition" />
    </Col>
    <Col
      span="4"
      class="search-btn">
      <Button type="primary" @click.stop="$emit('query')">查询</Button>
      <Button @click.stop="reset">重置</Button>
    </Col>
  </Row>
</template>

<script>
import SearchItem from './cell/searchItem'

export default {
  name: 'TuiSearch',
  components: { SearchItem },
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
    condition: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    list() {
      const Len = this.data.length
      const n = 4
      const list = []
      for (let i = 0; i < Math.ceil(Len / n); i++) {
        list[i] = this.data.slice(i * n, (i + 1) * n)
      }
      return list
    },
  },
  methods: {
    reset() {
      if (this.$refs.ref0) {
        this.$refs.ref0[0].selVal = '0'
      }
      if (this.$refs.ref1) {
        this.$refs.ref1[0].timeVal = ''
      }
      this.$emit('reset')
    },
  },
}
</script>

<style lang="scss" scoped>
.s-search{
  /deep/ .ivu-col{
    margin-bottom: 10px;
    display: flex;
    label{
      color: #666;
      line-height: 34px;
      margin-right: 10px;
    }
    >div{
      flex: 1;
    }
    .ivu-date-picker{
      width: 100%;
    }
  }
}

.search-btn{
  button{
    margin-right: 10px;
  }
}
 /deep/.ivu-col-span-4{
   padding-left:10px!important;
 }
</style>
